import styled, { css } from "styled-components";

import AtomSearchIcon from "Components/Atoms/Search/SearchIcon";
import AtomSearchInput from "Components/Atoms/Search/SearchInput";

const Wrap = styled.label`
   cursor: pointer;
   display: flex;
   align-items: center;
`;

const InputWrap = styled.div`
   position: relative;
   overflow: hidden;
   height: 30px;
   padding: 2px 0px;
`;

const AniBox = styled.div`
   width: 0px;
   input:focus + & {
      width: 240px;
   }
   transition-duration: 0.3s;
   transition-property: width;
   transition-timing-function: ease-in-out;
`;

const cssInput = css`
   position: absolute;
   right: 0px;
   top: 0px;
`;

function Search(props: any) {
   return (
      <Wrap>
         <AtomSearchIcon></AtomSearchIcon>
         <InputWrap>
            <AtomSearchInput {...props} css={cssInput}></AtomSearchInput>
            <AniBox></AniBox>
         </InputWrap>
      </Wrap>
   );
}

export default Search;
